import React from 'react';
export const FinalRemarks = ({ data, finalRating }) => {
    const finalData = data.replace(/\*\*/g, '');
    const individualSkills = finalData
        .split('\n\n')
        .map((content) => ({ skillName: content.split(':')[0].trim(), content }));
    const additionalLine =
        finalRating > 6
            ? '\n - Based on the interview, the candidate possesses the skills and competencies needed for the position and is recommended for advancement in the process.'
            : finalRating > 4
              ? '\n - The candidate shows potential but may require additional scrutiny in certain areas. They are cautiously recommended for further evaluation.'
              : '\n - Based on the evaluation, the candidate does not meet the necessary requirements for the position and is not recommended for further consideration.';
    return (
        <div className="detailed-feedback-list break-stop">
            <div className="skills-div">
                <span className="soft-skills-span">Final Remarks</span>
            </div>
            <div className="soft-skill-wrapperv2">
                <div className="soft-skill-content">
                    {individualSkills.map((skill, index) => (
                        <pre className="font-style-soft-skill" style={{ whiteSpace: 'pre-wrap' }}>
                            <code
                                dangerouslySetInnerHTML={{
                                    __html: `${
                                        skill?.skillName === 'Conclusion'
                                            ? `${skill.content.replace('**', '')}${additionalLine}`
                                            : skill.content.replace('**', '')
                                    }`,
                                }}
                            />
                        </pre>
                    ))}
                </div>
            </div>
        </div>
    );
};
